import { FC } from "react";

import "./Accordion.scss";
import { Module } from "../../../../types/CoursesTypes";

const Accordion: FC<Module> = ({ title, direction, subs, start }) => {
  const publicUrl = process.env.PUBLIC_URL;

  function change(t: EventTarget | HTMLElement) {
    if (t instanceof HTMLElement) {
      const accordion = t.classList.contains("accordion")
        ? t
        : t.parentElement?.classList.contains("accordion")
          ? t.parentElement
          : t.parentElement?.parentElement;

      const alreadyOpen = accordion?.classList.contains("open");

      document.querySelectorAll(".list-item.accordion").forEach((item) => {
        item.classList.remove("open");
      });

      if (!alreadyOpen) accordion?.classList.add("open");
    }
  }

  return (
    <li
      key={title}
      className={`list-item accordion ${start ? ` ${start} not-close` : ""}`}
      onClick={(e) => start !== "open" && change(e.target)}
    >
      <div className={`list-item__content ${direction}`}>
        {title && (
          <p
            className="list-item__title"
            dangerouslySetInnerHTML={{ __html: `${title}` }}
          ></p>
        )}
        <img
          className="list-item__img"
          src={`${publicUrl}/img/course/icons/check-module.svg`}
          alt={title}
        />
      </div>
      <div className="list-item__hidden-content">
        {subs?.map((info) => (
          <p key={info} className="list-item__title">
            &#10148; {info}
          </p>
        ))}
      </div>
    </li>
  );
};

export default Accordion;
